// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___2BWnI","logo":"styles-module__logo___276wn","proBadge":"styles-module__proBadge___23CEn"};